export const getImportFiltersErrorTranslations = t => {
  const translations = t => ({
    dataCorrupted: t("errors.importFilters.dataCorrupted"),
    mismatchedLevelsNumber: t("errors.importFilters.mismatchedLevels")
  });

  return translations(t !== undefined ? t : str => str);
};
